var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAchievements(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Query stats",
    clipPath: "url(#clip0_26423_9282)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M19.88 18.97C20.32 18.27 20.58 17.46 20.58 16.58C20.58 14.09 18.57 12.08 16.08 12.08C13.59 12.08 11.58 14.09 11.58 16.58C11.58 19.07 13.59 21.08 16.07 21.08C16.95 21.08 17.77 20.82 18.46 20.38L21.58 23.5L23 22.08L19.88 18.97ZM16.08 19.08C14.7 19.08 13.58 17.96 13.58 16.58C13.58 15.2 14.7 14.08 16.08 14.08C17.46 14.08 18.58 15.2 18.58 16.58C18.58 17.96 17.46 19.08 16.08 19.08ZM15.72 10.58C14.98 10.6 14.27 10.76 13.62 11.03L13.07 10.2L9.27 16.38L6.26 12.86L2.63 18.67L1 17.5L6 9.5L9 13L13 6.5L15.72 10.58ZM18.31 11.08C17.67 10.8 16.98 10.63 16.26 10.59L21.38 2.5L23 3.68L18.31 11.08Z",
    fill: "#8E97A3"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_26423_9282"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAchievements);
export default __webpack_public_path__ + "static/media/achievements.6695c2cfb689abfa928e4d2b888f270d.svg";
export { ForwardRef as ReactComponent };